import { useAppSelector } from "../../../app/hooks"
import { selectSeekbarPosition, selectAudioDuration } from "../data/articleSlice"
import { StyledArticleTime } from "../styled/StyledArticleTime.styled"

export const ArticleTime = () => {

    const seekbarPosition = useAppSelector(selectSeekbarPosition)
    const audioDuration = useAppSelector(selectAudioDuration)

    return (
        <StyledArticleTime>{seekbarPosition.minutesAndSecs}/{audioDuration.minutesAndSecs}</StyledArticleTime>
    )
}